import { render, staticRenderFns } from "./PortalAdminContent.vue?vue&type=template&id=946d549e&scoped=true&"
import script from "./portalAdminContent.ts?vue&type=script&lang=ts&"
export * from "./portalAdminContent.ts?vue&type=script&lang=ts&"
import style0 from "./PortalAdminContent.vue?vue&type=style&index=0&id=946d549e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946d549e",
  null
  
)

export default component.exports